var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 5,
    fill: "#78A6BE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1402_9628)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 12H25V10C25 9.46957 24.7893 8.96086 24.4142 8.58579C24.0391 8.21071 23.5304 8 23 8H17C16.4696 8 15.9609 8.21071 15.5858 8.58579C15.2107 8.96086 15 9.46957 15 10V12H10V14H12V29C12 29.7956 12.3161 30.5587 12.8787 31.1213C13.4413 31.6839 14.2044 32 15 32H25C25.7956 32 26.5587 31.6839 27.1213 31.1213C27.6839 30.5587 28 29.7956 28 29V14H30V12ZM17 10H23V12H17V10ZM26 29C26 29.2652 25.8946 29.5196 25.7071 29.7071C25.5196 29.8946 25.2652 30 25 30H15C14.7348 30 14.4804 29.8946 14.2929 29.7071C14.1054 29.5196 14 29.2652 14 29V14H26V29Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 17.9995H17V25.9995H19V17.9995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 17.9995H21V25.9995H23V17.9995Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1402_9628"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.dcc0b0a4c81d888e4d302433e69a1ca2.svg";
export { ForwardRef as ReactComponent };